import styled, { css } from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import { scale } from './animations'
import Button from './StyledButton'

const Form = styled.form`
  position: relative;
  counter-reset: fieldset;

  ${props =>
    props.modal &&
    css`
      z-index: 2;
      padding: 48px;

      ${Form.Error} {
        padding-left: 48px;
        padding-right: 48px;
      }

      ${maxWidth(vars.breakpoints.tablet)`
        padding: 40px;

        ${Form.Error} {
          padding-left: 40px;
          padding-right: 40px;
        }
      `}

      ${maxWidth(vars.breakpoints.tablet - 1)`
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      `}

      ${maxWidth(vars.breakpoints.lMobile)`
        padding: 32px 20px;

        ${Form.Error} {
          padding-left: 20px;
          padding-right: 20px;
        }
      `}
    `}
`

Form.Title = styled.h2`
  margin-bottom: 24px;
  font-weight: 300;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: var(--color-main);

  ${maxWidth(vars.breakpoints.tablet)`
    margin-bottom: 16px;
    font-size: 28px;
  `}

  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}
`

Form.Desc = styled.p`
  margin-bottom: 34px;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-secondary);

  ${props =>
    props.centered &&
    css`
      text-align: center;
    `}

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 14px;
  `}
`

Form.Error = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  font-weight: normal;
  background: var(--color-error);
  color: #fff;
  animation: ${scale} 0.3s ease-in-out;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 14px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    padding-top: 6px;
    padding-bottom: 6px;
  `}
`

Form.Block = styled.div`
  margin-bottom: 48px;

  ${props =>
    props.styledLast &&
    css`
      margin-bottom: 32px;
    `}
`

Form.Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 24px 32px;
  margin-bottom: 24px;

  ${maxWidth(vars.breakpoints.tablet)`
    grid-gap: 24px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    grid-template-columns: 1fr;
  `}

  &:last-child {
    margin-bottom: 0;
  }
`

Form.Item = styled.div`
  &:only-child {
    grid-column: ${props => !props.single && '1 / -1'};
  }
`

Form.Submit = styled.div`
  --button-width: 324px;
  text-align: center;

  ${Button} {
    margin: 0 auto;
    min-height: 40px;
    padding: 5px 35px;
    font-size: 16px;
  }

  ${props =>
    props.styledWide &&
    css`
      --button-width: 100%;
    `}

  ${maxWidth(vars.breakpoints.mTablet)`
    --button-width: 100%;
    --button-padding-top: 17px;
    --button-padding-bottom: 17px;
  `}
`

Form.Footer = styled.div`
  padding-top: 24px;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  color: var(--color-secondary);

  a {
    color: var(--color-decor);
    text-decoration-line: underline;
  }

  ${maxWidth(vars.breakpoints.mTablet)`
    font-size: 12px;
  `}
`

export default Form
